import { Navigation } from './Navigation';
import { RfrncDtItemsVO } from './EligibilityModels/RfrncDtItemsVO';

export class AssistanceSearchConfirmModel extends Navigation {

    public rfrncDtItemsVO: RfrncDtItemsVO;
    phoneNumber:string;
    email:string;
    userRoleType:string;
    userId:number;
    phoneType:number;
    assisterId:string;
}